var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "panel-body" },
      _vm._l(_vm.comments, function (comment) {
        return _c("div", { key: comment.id }, [
          _c("div", { staticClass: "media" }, [
            _c(
              "div",
              { staticClass: "media-left" },
              [
                _c("q-avatar", {
                  attrs: { size: 50, src: comment.userAvatar },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "media-body",
                staticStyle: { "padding-left": "15px" },
              },
              [
                _c("h4", { staticClass: "media-heading" }, [
                  _c("span", [_vm._v(_vm._s(comment.user))]),
                  _vm._v(" "),
                  _c("small", [_vm._v(_vm._s(comment.time))]),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(comment.text))]),
                _vm._v(" "),
                _c("comments", { attrs: { comments: comment.replies } }),
              ],
              1
            ),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }